// src/components/AmazonSearch.js
// This component provides an interface for searching Amazon for board games
import React, { useState } from 'react';

/**
 * Component to provide Amazon search link for finding copies of a board game
 * @param {Object} props
 * @param {string} props.gameTitle - The title of the game to search for
 */
const AmazonSearch = ({ gameTitle }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // Format the game title for Amazon search URL
  const formattedTitle = encodeURIComponent(`${gameTitle} board game`);
  // Add your Amazon affiliate tag here
  const affiliateTag = "bestboardg046-20"; // Replace with your actual Amazon affiliate ID
  const amazonUrl = `https://www.amazon.com/s?k=${formattedTitle}&tag=${affiliateTag}`;
  
  return (
    <div className="mb-4">
      <div className="bg-gray-800 rounded-lg border border-gray-700 p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="/media/amazon-logo.png" 
              alt="Amazon" 
              className="h-6 mr-2"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='30' viewBox='0 0 60 30'%3E%3Crect width='60' height='30' fill='%23232F3E'/%3E%3Ctext x='30' y='15' font-family='Arial' font-size='12' fill='%23FF9900' text-anchor='middle' dominant-baseline='middle'%3EAmazon%3C/text%3E%3C/svg%3E";
              }}
            />
            <span className="text-gray-300">Search for this game on Amazon</span>
          </div>
          
          <div className="flex space-x-2">
            <a 
              href={amazonUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="px-3 py-1 bg-yellow-600 hover:bg-yellow-700 text-white rounded-md text-sm transition-colors"
            >
              Search Amazon
            </a>
            
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-gray-400 hover:text-gray-200"
            >
              {isExpanded ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              )}
            </button>
          </div>
        </div>
        
        {isExpanded && (
          <div className="mt-4 text-sm text-gray-400">
            <p>
              The "Search Amazon" button will take you to Amazon's search results for "{gameTitle}". 
              Prices and availability may vary.
            </p>
            <p className="mt-2">
              As an Amazon Associate, we earn from qualifying purchases made through our links.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AmazonSearch;